<div class="grid__cell box-shadow rounded--large guts-p-full-2 m-guts-p-full-1">
  <div class="l_flexbar">
    <h1 class="h3 l_flex" [innerHtml]="chartName"></h1>
    <df-icon
      [attr.aria-label]="tooltip"
      [ngbTooltip]="tooltip"
      icon="question-mark-circle"
      tabindex="0"
      class="color-ebony-a45 text-top guts-m-l-half"
      role="text"
      placement="bottom"
    ></df-icon>
  </div>
  <div class="l_flexbar guts-m-b-1">
    <div class="l_flex-grow">
      <p
        *ngIf="subtitle"
        class="par par--light par--small"
        [innerHtml]="subtitle"
      ></p>
    </div>
  </div>
  <div id="highcharts" class="highcharts"></div>
  <div class="l_flexbar">
    <div class="l_flex-grow">
      <p
        *ngIf="bottomText"
        class="par par--light par--small"
        [innerHtml]="bottomText"
      ></p>
    </div>
  </div>
</div>
